import React from 'react';
import { Toaster as Sonner } from 'sonner';
import styles from './sonner.module.css';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            className="toaster group"
            closeButton={true}
            toastOptions={{
                classNames: {
                    toast: [
                        'group toast group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:shadow-xl',
                        'bg-card text-card-foreground',
                        'flex flex-wrap items-start p-4 pt-5 gap-3',
                        'relative overflow-hidden',
                        styles.toast, // Hook for CSS module styles
                    ].join(' '),
                    description: 'group-[.toast]:text-muted-foreground',
                    actionButton: [
                        'group-[.toast]:bg-card group-[.toast]:text-foreground group-[.toast]:border group-[.toast]:border-border group-[.toast]:hover:bg-accent',
                        'group-[.toast]:transition-colors group-[.toast]:shadow-sm',
                        'font-medium text-sm rounded-md px-4 py-2',
                        'w-full order-3 mt-1 justify-center',
                    ].join(' '),
                    cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                    closeButton: styles.closeButton,
                    title: 'text-sm font-medium leading-tight flex-1',
                    icon: 'mr-0',
                },
            }}
            {...props}
        />
    );
};

export { Toaster };
